import React, {useContext, useState} from "react"
import PropTypes from "prop-types";
import Loading from "components/Loading";
import FormTranslationContext from "context/FormTranslationContext";
import {Table, TableBody, TableHead, TableRow, Tooltip} from "@material-ui/core";
import AnnualReportTableCell from "../common/AnnualReportTableCell";
import Tr from "translations/Translations";
import AnnualReportEditPopup from "../common/AnnualReportEditPopup";
import AnnualReportSocialEditForm from "./AnnualReportSocialEditForm";
import annualReportSteps from "../../constants/annualReportSteps";
import AnnualReportSearchBar from "../common/AnnualReportSearchBar";
import AnnualReportTableHeadCell from "../common/AnnualReportTableHeadCell";
import AnnualReportTablePart from "../common/AnnualReportTablePart";
import MoveAnnualReportEntry from "../common/MoveAnnualReportEntry";
import formatAmountNumber from "libs/formatAmountNumber";
import formatBoolean from "libs/formatBoolean";
import formatInteger from "libs/formatInteger";
import annualReportTenderMode from "../../constants/annualReportTenderMode";

const reportStep = annualReportSteps.social;

function AnnualReportSocialForm(
    {
        initValues,
        classes,
        disabled
    }
) {
    const {getDict, dictTranslations} = useContext(FormTranslationContext);
    const [types] = useState(getDict("MP.MMiA.OrdersType"));
    const [editPopup, setEditPopup] = useState(null);
    const [movePopup, setMovePopup] = useState(null);
    const [search, setSearch] = useState({search: ""});

    const getRowValues = (entry) => ([
        entry.number,
        entry.source ? dictTranslations.source[entry.source] : null,
        entry.noticeNumber,
        entry.orderType ? dictTranslations.orderType[entry.orderType] : null,
        entry.codeCpv ? <Tooltip title={entry.codeCpv.name}><span>{entry.codeCpv.publicCode}</span></Tooltip> : null,
        annualReportTenderMode(entry, dictTranslations),
        formatAmountNumber(entry.contractValue),
        formatInteger(entry.numberOfAwardedLots),
        formatInteger(entry.numberOfOffers),
        formatBoolean(entry.reservedTender),
        formatBoolean(entry.inDescriptionRequirementsForAccessibility),
        formatBoolean(entry.definedSocialAspectsInOfferEvaluationCriteria),
        formatBoolean(entry.definedRequirementsBasedOnEmploymentRelationship),
        formatBoolean(entry.definedSocialAspectsRequirements),
        formatBoolean(entry.definedLabelRelatedToSocialAspects),
        dictTranslations.contractorType[entry.contractorType],
    ])

    if (!initValues) return <Loading/>
    return <>
        <AnnualReportSearchBar reportStep={reportStep} setSearch={setSearch} classes={classes} disabled={disabled} setEditPopup={setEditPopup}/>

        <Table>
            <TableHead>
                <TableRow className={classes.tableMainHeaderRow}>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.number`}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.source`}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.noticeNumber`}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.orderType`}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.codeCpv`}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.tenderModeBzp`}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.contractValue`}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.numberOfAwardedLots`}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.numberOfOffers`}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.reservedTender`} maxWidth={100}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.inDescriptionRequirementsForAccessibility`} maxWidth={130}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.definedSocialAspectsInOfferEvaluationCriteria`} maxWidth={100}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.definedRequirementsBasedOnEmploymentRelationship`} maxWidth={100}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.definedSocialAspectsRequirements`} maxWidth={100}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.definedLabelRelatedToSocialAspects`}/>
                    <AnnualReportTableHeadCell label={`mmia.${reportStep}.contractorType`}/>
                    <AnnualReportTableCell borderLeft borderRight colSpan={2}></AnnualReportTableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    types.map((type) =>
                        <AnnualReportTablePart
                            key={type.value}
                            classes={classes}
                            type={type.value}
                            reportStep={reportStep}
                            partName={dictTranslations.type[type.value]}
                            disabled={disabled}
                            entries={initValues[type.value]}
                            search={search}
                            setEditPopup={setEditPopup}
                            setMovePopup={setMovePopup}
                            columnCount={16}
                            getRowValues={getRowValues}
                        />
                    )
                }
            </TableBody>

        </Table>

        {
            !!editPopup &&
            <AnnualReportEditPopup
                onClose={() => setEditPopup(null)}
                config={editPopup}
                reportStep={annualReportSteps.social}
                FormComponent={AnnualReportSocialEditForm}
            />
        }
        {
            !!movePopup &&
            <MoveAnnualReportEntry
                items={types.filter((item) => item.value !== movePopup.currentType)}
                onClose={() => setMovePopup(null)}
                inputLabel={Tr("order_type")}
                reportStep={reportStep}
                config={movePopup}
            />
        }
    </>


}

AnnualReportSocialForm.prototype = {
    initValues: PropTypes.object.isRequired,
    disabled: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired
}

export default AnnualReportSocialForm;